import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminVhostsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('vhost');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
